module.exports = __webpack_public_path__ + "img/how-it-works3.32e61faf.svg";